export const generateLobbyUrl = (uiAddress: string, searchParams: URLSearchParams): string => {
  return `${uiAddress}?${searchParams.toString()}`;
};

export const detectPortrait = (): boolean => {
  if (typeof window.screen !== 'undefined' && screen.orientation) {
    return screen.orientation.type.startsWith('portrait');
  }
  return window.innerHeight > window.innerWidth;
};
